module.exports = __webpack_public_path__ + "static/img/dialog3.45d8bc1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dialog3.jpg
// module id = 16jR
// module chunks = 160